import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { login } from '../lib/auth'
import GuestHeader from '../components/GuestHeader'

export default function LoginPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const isFieldMissing = (val) => submitted && !val

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitted(true)

    if (!email || !password) return

    setError(null)
    setLoading(true)

    try {
      await login(email, password)
      navigate('/dashboard')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-paper">
      <GuestHeader />
      <div className="flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          <div className="bg-surface border-[1.5px] border-ink p-6">
          <h2 className="text-xl font-extrabold text-ink mb-4">Sign in</h2>

          {error && (
            <div className="text-sm text-accent-dark bg-accent/10 border border-accent/40 p-3 mb-4">
              {error}
              {error.toLowerCase().includes('confirm') && (
                <Link to="/resend-confirmation" className="block mt-2 text-accent hover:text-accent-dark underline">
                  Resend confirmation email
                </Link>
              )}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full border border-gray-400 rounded-md px-3 py-2.5 text-base sm:text-sm focus:ring-2 focus:ring-accent focus:border-accent ${isFieldMissing(email) ? 'border-accent' : ''}`}
              />
              {isFieldMissing(email) && <p className="text-xs text-accent-dark mt-1">Required</p>}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full border border-gray-400 rounded-md px-3 py-2.5 text-base sm:text-sm focus:ring-2 focus:ring-accent focus:border-accent ${isFieldMissing(password) ? 'border-accent' : ''}`}
              />
              {isFieldMissing(password) && <p className="text-xs text-accent-dark mt-1">Required</p>}
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 px-4 text-sm font-bold text-white bg-accent rounded-md hover:bg-accent-dark disabled:opacity-50"
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          <p className="mt-4 text-sm text-center text-gray-500">
            <Link to="/forgot-password" className="text-accent hover:text-accent-dark">
              Forgot your password?
            </Link>
          </p>
          <p className="mt-2 text-sm text-center text-gray-500">
            Don't have an account?{' '}
            <Link to="/get-started" className="text-accent hover:text-accent-dark">
              Get Started
            </Link>
          </p>
        </div>
        </div>
      </div>
    </div>
  )
}
